import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IRowsErrorMessage, IRowsErrorsResponse } from '../../models/imports.models';
export interface IDataType {
  error: IRowsErrorMessage;
  rowsErrorsResponse: IRowsErrorsResponse
}
@Component({
  selector: 'app-preview-errors',
  templateUrl: './preview-errors.component.html',
  styleUrls: ['./preview-errors.component.scss']
})
export class PreviewErrorsComponent implements OnInit {

  constructor(
    private dialogRef: MatDialogRef<PreviewErrorsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IDataType,
  ) { }

  ngOnInit(): void {
  console.log(this.data);

  }

  getFieldIndex(fieldName: string): string {    
    const index = this.data.rowsErrorsResponse.matches.fields.indexOf(fieldName);
    return index !== -1 ? this.data.rowsErrorsResponse.matches.columns[index] : '';
  }
  objectKeys(obj: any): string[] {
    return Object.keys(obj);
  }

  objectValues(obj: any): string[] {
    return Object.values(obj);
  }

  close(){
    this.dialogRef.close();
  }
}
